import Component from '../Component';
import { GrowthStage, tCropTextureMap } from '../../State/World/IFieldData';
import GameObject from '../../GameObject/GameObject';

export default class CropComponent extends Component {
    public id: string = undefined;
    public x: number = undefined;
    public y: number = undefined;
    public sector: number = undefined;
    public base: string = undefined;

    public field: string = undefined;
    public defaultTextures: tCropTextureMap = undefined;
    public textures: tCropTextureMap = {
        [GrowthStage.LOCKED]: undefined,
        [GrowthStage.READY]: undefined,
        [GrowthStage.HARVESTED]: undefined,
        [GrowthStage.GROWING]: undefined,
    };
    public rewardObjects: GameObject[] = undefined;
}

